export default {
    computed: {
        isLogged() {
            return !!(this.$store.state.user || sessionStorage.getItem('user'));
        },
    }
}
